import { TFunction } from 'i18next'

import { ResidentCell } from '@/components/business/units'
import { Badge } from '@/components/ui/badge'
import { TableColumn } from '@/components/ui/table'
import { EMPTY_VALUE } from '@/constants'
import { UnitLeaseResident } from '@/models/features'
import { formatDateLong } from '@/utils/date'

interface GetLeaseResidentsColumnsProps {
  leaseHolder: UnitLeaseResident | null
  t: TFunction<['units']>
}

export const getLeaseResidentsColumns = ({
  leaseHolder,
  t,
}: GetLeaseResidentsColumnsProps): TableColumn<UnitLeaseResident>[] => [
  {
    id: 'name',
    render: (resident) => <ResidentCell resident={resident} />,
    title: t('units:lease.residents.columns.name'),
    width: '28rem',
  },
  {
    id: 'role',
    render: (resident) =>
      resident === leaseHolder ? (
        <Badge color="green" size="small" variant="light">
          {t('units:lease.residents.roles.leaseHolder')}
        </Badge>
      ) : (
        <Badge color="neutral" size="small" variant="light">
          {t('units:lease.residents.roles.occupant')}
        </Badge>
      ),
    title: t('units:lease.residents.columns.role'),
    width: '18rem',
  },
  {
    id: 'email',
    render: (resident) => resident.email || EMPTY_VALUE,
    title: t('units:lease.residents.columns.email'),
    width: '28rem',
  },
  {
    id: 'moveIn',
    render: (resident) => formatDateLong(resident.moveInDate),
    title: t('units:lease.residents.columns.moveIn'),
    width: '16rem',
  },
  {
    id: 'moveOut',
    render: (resident) => formatDateLong(resident.moveOutDate),
    title: t('units:lease.residents.columns.moveOut'),
    width: '16rem',
  },
]
